function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getApp, getApps, initializeApp } from '@firebase/app';
import { getFirestore } from '@firebase/firestore';
export class Fuego {
  constructor(config) {
    _defineProperty(this, "db", void 0);

    this.db = !getApps().length ? getFirestore(initializeApp(config)) : getFirestore(getApp());
  }

}
//# sourceMappingURL=Fuego.js.map